const companyInfoMap = [
    {
        title: 'Company Info',
        perRow: 3,
        arr: [
            {
                key: 'name',
                type: 'text',
                val: '',
                label: 'Name',
                required: true,
                fullWidth: false
            },
            {
                key: 'billingName',
                type: 'text',
                val: '',
                label: 'Billing Name',
                required: false,
                fullWidth: false
            },
            {
                key: 'billFileId',
                type: 'autoComplete',
                val: 'allBillFileId',
                label: 'Bill File Id',
                returnKey: 'name',
                displayKey: 'name',
                required: false,
                fullWidth: false
            },
            {
                key: 'advertiserId',
                type: 'text',
                val: '',
                label: 'Advertiser Id',
                required: false,
                fullWidth: false
            },
        ]
    }
];

const companyEmailsMap = [
    {
        key: 'email',
        type: 'text',
        val: '',
        label: 'Email',
        required: true,
        fullWidth: false
    },
    {
        key: 'primaryEmail',
        type: 'switch',
        val: '',
        label: 'Is Primary Email',
        required: true,
        fullWidth: false
    },
];

export { companyInfoMap, companyEmailsMap };
